import React from 'react';
import { Button, Card, CardActions, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useHistory } from 'react-router';

// this is the cell for the sidebar
const useStyles = makeStyles({
  root: {

    fontFamily: [
      'Montserrat', 
      'sans-serif',
    ].join(','),
    minWidth: 275,
    marginBottom: '25px',
    marginTop: '-8px',
    marginLeft: '-10px',
    marginRight: '-10px',
    borderRadius: 'none',
    boxShadow: "none",
    border: "0.7px solid #E8E8E8",
    height: '122px',
    "&:hover": {
      cursor: 'pointer',
      boxShadow: "-2px 1px 10px 10px rgba(0,0,0,0.1)",
    },
    
  },

  title: {
    fontSize: 16,
    textTransform: 'uppercase',
    fontFamily: [
      'Montserrat', 
      'sans-serif',
    ].join(','),
    fontWeight: 500,
    marginLeft: '10px',
    marginTop: '-2px'
  },
  date: {
    fontSize: '12px',
    
    fontFamily: [
      'Montserrat', 
      'sans-serif',
    ].join(','),
    marginTop: '7px',
    marginLeft: '10px'
   
  },
  pos: {
    marginBottom: 12,
  },
  space: {
    marginLeft: 40,
    marginRight: 10,
  },
  spaceDate: {
  marginRight: '10px',
  },
  arrow: {
  fontSize: '1.5rem',
  marginLeft: '-7px'
  },
  button: {
    
    fontSize: '12px',
    fontFamily: [
      'Montserrat', 
      'sans-serif',
    ].join(','),
    fontWeight: 600,
    marginLeft: 274 ,
    marginTop: '-18px',
    '&:hover': {
    backgroundColor: 'transparent',
    color: '#DC251A',
    },
    '&:focus': {
      border: "none",
      outline: "none",
      color: '#DC251A',
    }
  },

});



const Cells = ({row, onEventClick}) => {
 
  const classes = useStyles();
  const history = useHistory()

const clickEvent = (id, sub) => {
  onEventClick(id)
   history.push({place: sub.values.place, eventType: sub.values.eventType, eventDate: sub.values.eventDate, eventDescription: sub.values.eventDescription, recordId: sub.values.id })
   console.log(history)
}

  /* i dati della tabella li troviamo all'interno della prop passata
row.subRows  ed i valori sono qui sub.values.col1. 
quindi: sub.values + il nome della colonna interessata. */
  return (
    <> 
      {row.subRows.map(sub => (
        <div key={sub.id} style={{marginBottom: '-20px'}}>
          <Card className={classes.root}>
          <CardActions onClick={() => history.push(`/tabpanel/${sub.values.id}`, {place: sub.values.place, eventType: sub.values.eventType, eventDate: sub.values.eventDate, eventDescription: sub.values.eventDescription  }) }>
            <CardContent>
              <Typography className={classes.title} variant="h5" component="h2">
                 {sub.values.place}'S {sub.values.eventType} {sub.values.eventDate}
              </Typography>
              <Typography className={classes.date} color="textSecondary" gutterBottom>
                <span className={classes.spaceDate}>DATE</span> {sub.values.eventDate} <span className={classes.space}>PLACE</span>  {sub.values.place}
              </Typography>
            </CardContent>
            </CardActions>
            <CardActions>
            <div style={{marginTop: '-25px'}}>
              <Button onClick={() => clickEvent(sub.original.id, sub )} className= {classes.button}size="small">NEWS CIRCULATION MAP<ChevronRightIcon className= {classes.arrow}/></Button>
              </div>
            </CardActions>
          </Card>
      </div>
      ))}
    </>
  )
};

export default Cells;